import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import {SlButton, SlFormEntryRow, SlRadioButton, TextInput, SlBusyIndicator} from "./editors";

import {documentActions} from "../_actions";
import {metadataService} from "../_services";
import {IdentificationType} from "./subcomponents/IdentificationType";
import ViewDocument from "./ViewDocument";

const DocumentPage = (props) => {
    const [urlHash, setUrlHash] = useState('');
    const [formValue, setFormValue] = useState({
            SocialSecurityNumber: '',
            DOB: '',
            IndividualTaxIdentificationNumber: '',
            identityType: '',
            useSSN: ''
        });

    useEffect(() => {
        // grab the hash from the url in params
        if(props.match.params.hash){
            setUrlHash(props.match.params.hash);
        }
    }, []);

    const handleInput = ({ target: { name, value } }) => {
        let result = { ...formValue, [name]: value }
        if (name == "SocialSecurityItin") {
            if (value.SocialSecurityNumber) {
                result.SocialSecurityNumber = value.SocialSecurityNumber;
            }
            else if (value.IndividualTaxIdentificationNumber) {
                result.IndividualTaxIdentificationNumber = value.IndividualTaxIdentificationNumber;
            }
        }

        setFormValue(result)
    }

    const handleSubmit = () => {
        if(formValue.SocialSecurityNumber || formValue.IndividualTaxIdentificationNumber) {
            if(formValue.DOB) {
                props.actions.fetchDocumentByIdHash(formValue, urlHash);
            }
        }
    }

    const isIdentificationTypeValid = (fieldName, isValid) => {
        return { formError: !isValid, ssnItinError: !isValid }
    }



    return (
        <div>
            {props.documentImage.length > 0 ?
                <ViewDocument document={props.document} documentImage={props.documentImage} />
            :
                <div>
                    <IdentificationType
                        name={"SocialSecurityItin"}
                        isRequired={true}
                        showLabel={true}
                        // fieldErrors={this.state.fieldErrors}
                        onChange={handleInput}
                        isValid={isIdentificationTypeValid}
                    />
                    <SlFormEntryRow>
                        <TextInput
                            name="DOB"
                            type="date"
                            onChange={handleInput}
                            value={formValue.DOB}
                        />
                    </SlFormEntryRow>
                    <SlFormEntryRow>
                        <div style={{textAlign: "center"}}>
                            {props.loadingHash ?
                                <SlBusyIndicator visible={props.loadingHash}/>
                                :
                                <SlButton onClick={handleSubmit} name={"Submit"} disabled={props.loadingHash}/>
                            }
                        </div>
                    </SlFormEntryRow>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        loadingHash: state.documents.documentByHashLoading,
        document: state.documents.documentDetails,
        documentImage: state.documents.documentByHash,
        documentType: state.documents.documentByHashType,
        hashError: state.documents.fetchImgError
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: {
            fetchDocumentByIdHash: (data, urlHash) => {
                dispatch(documentActions.fetchDocumentByIdHash(data, urlHash))
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentPage);
